import axios from 'axios';
import { loginRequest } from '../../../auth/msalConfig';
import { MsalUtils } from '../../../utils/msalUtils';

const axiosClient = axios.create({
  baseURL: window.ENV?.API_BASE_URL || import.meta.env.VITE_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosClient.interceptors.request.use(
  async (config) => {
    try {
      const accounts = await MsalUtils.getAllAccounts();

      if (accounts.length > 0) {
        const silentRequest = {
          ...loginRequest,
          account: accounts[0],
        };

        const response = await MsalUtils.acquireTokenSilent(silentRequest);
        config.headers.Authorization = `Bearer ${response.accessToken}`;
      }
    } catch (error) {
      console.log(error);
      // If token acquisition fails, the request will proceed without token
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      try {
        await MsalUtils.clearCache();
      } catch (clearError) {
        console.warn('Failed to clear MSAL cache:', clearError);
      }
    }
    return Promise.reject(error);
  },
);

export default axiosClient;
